import mainApiClient from '../interceptor.mainApiClient';

const patternOfLifeEndpoints = {
  get: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/pattern-of-life`, config),

  rebuild: (alienId, config) =>
    mainApiClient.post(`/api/v1/aliens/${alienId}/pattern-of-life/rebuild`, null, config),

  checkDeviation: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/pattern-of-life/deviation`, config),

  detectAnomaly: (alienId, config) =>
    mainApiClient.post(`/api/v1/aliens/${alienId}/pattern-of-life/anomaly/detect`, null, config),

  trainAnomaly: (alienId, config) =>
    mainApiClient.post(`/api/v1/aliens/${alienId}/pattern-of-life/anomaly/train`, null, config),

  getAnomalyHistory: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/pattern-of-life/anomaly/history`, config),
};

export default patternOfLifeEndpoints;
